document.addEventListener("DOMContentLoaded", () => {
    const btn = document.getElementById("ViewMoreBtn");

    if (!btn) return;

    btn.addEventListener("click", async function () {

        const nextPage = this.dataset.nextPage;

        this.disabled = true;
        this.textContent = "Loading...";

        try {

            const url =
                window.location.pathname +
                window.location.search +
                (window.location.search ? "&" : "?") +
                "page=" +
                nextPage;

            const response = await fetch(url);
            const html = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const newProducts = doc.querySelectorAll("#product-grid > li");
            const currentGrid = document.querySelector("#product-grid");

            newProducts.forEach(item => {
                currentGrid.appendChild(item);
            });

            const nextBtn = doc.querySelector("#ViewMoreBtn");

            if (nextBtn) {
                this.dataset.nextPage = nextBtn.dataset.nextPage;
                this.disabled = false;
                this.textContent = "View More";
            } else {
                this.remove();
            }

        } catch (e) {
            console.error(e);
            this.disabled = false;
            this.textContent = "View More";
        }

    });
});